<template>
  <div>
    <el-dialog
      title="添加评论"
      :visible.sync="show"
      :before-close="handleClose"
      append-to-body
      width="1200px"
    >
      <div class="dialog-common-xb" style="margin-top: -10px">
        <div
          class="col-lg-12 list-header pad-header-bg clearfix"
          id="div-resize"
          style="background-color: white; padding: 10px 0; margin-top: -10px"
        >
          <div class="header-item-fix" style="margin: 0px">
            <!-- <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.creator"
              placeholder="搜索发稿人"
              @keyup.enter.native="search"
            ></b-form-input> -->
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.contentKeyword"
              placeholder="请输入评论内容"
              @keyup.enter.native="search"
              style="margin-left: 10px"
            ></b-form-input>
            <b-button
              size="sm"
              variant="primary"
              @click="search()"
              style="margin-left: 5px"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
              style="margin-left: 5px"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
            <b-button
              style="margin-left: 5px"
              size="sm"
              variant="primary"
              @click="addComment()"
            >
              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
              添加
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="getList"
              style="margin-left: 5px"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              刷新
            </b-button>
          </div>
          <!-- <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.showState"
              class="form-select"
              type="text"
            ></b-form-select>
          </div> -->
          <div class="header-item-fix" style="margin: 0px">
            <search-tag-name
              ref="searchTagNameRef"
              :multiple="true"
              @change="searchTagChange"
            ></search-tag-name>
          </div>
          <div class="header-item-fix" style="margin: 0px">
            <b-form-select
              @change="search()"
              v-model="pageParams.source"
              class="form-select"
              :options="sourceList"
              type="text"
            ></b-form-select>
          </div>
        </div>

        <!-- <div style="flex-shrink: 0" id="header-haha"></div> -->
        <!-- <div
          style="
            width: 100%;
            height: 20px;
            'margin-top':5px ;
            'background-color':gray ;
          "
          v-for="(tr, index) in content"
          :key="index"
          id="div-resize"
        ></div> -->
        <div
          :style="{
            'flex-shrink': 1,
            overflow: tableHeadFixed ? 'hidden' : 'auto',
          }"
        >
          <t-table
            size="medium"
            rowKey="id"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="items"
            stripe
            :max-height="screen_height - searchHeight - 230"
            :selected-row-keys="selectedRowKeys"
            @select-change="rehandleSelectChange"
          >
            <template #attachment="{ row }">
              <img v-if="row.image" class="w-3-rem" :src="row.image" alt />
              <img
                v-if="!row.image"
                class="w-3-rem"
                src="@/assets/images/default_cover_1_1.png"
                alt=""
              />
            </template>
            <template #title="{ row }">
              <span>{{ row.title || "--" }}</span>
            </template>
            <template #link="{ row }">
              <span>{{ row.link || "--" }}</span>
            </template>
            <template #tag="{ row }">
              <span>{{ row.tag || "--" }}</span>
            </template>
          </t-table>
        </div>
        <pagination
          :total="pageTotal"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          :pageSizes="[30, 50, 100]"
          @pageCallback="pageCallback"
          ref="page"
          style="flex-shrink: 0; margin-bottom: -15px"
        ></pagination>
      </div>

      <div slot="footer">
        <button
          @click="handleClose()"
          class="btn btn-sm btn-outline-dark"
          type="button"
          style="margin-right: 10px"
        >
          取消
        </button>
        <button @click="save()" class="btn btn-sm btn-primary" type="button">
          确定
        </button>
      </div>
    </el-dialog>
    <detail @pageCallback="pageCallback" ref="detail"></detail>
  </div>
</template>

<script>
import detail from "./operate-comment/detail";
import article from "@/server/api/article";
import pagination from "@/components/pagination/pagination.vue";
import searchTagName from "@/components/searchTagName";
import comment from "@/server/api/commentOperate";
export default {
  components: {
    pagination,
    searchTagName,
    detail,
  },

  data() {
    return {
      screen_height: 0,
      tableHeadFixed: true, //表头固定
      element: null,
      timer1: 100,
      timer2: 200,
      searchHeight: 51, //表头固定时填入搜索栏高度，如果搜索栏高度是动态变化的就不要固定表头
      showLoading: false,
      pageTotal: 0,
      pageParams: {
        content: "",
        type: "",
        pageSize: 30,
        page: 1,
        tagId: "",
        source: "",
        contentKeyword: "",
        commentType: 0,
      },
      showState: "",
      items: [],
      show: false,
      userTypes: [
        { text: "筛选类型", value: "" },
        // { text: "普通用户", value: "0" },
        { text: "吉视通号", value: 1 },
        { text: "专题/栏目", value: 2 },
        { text: "广电矩阵", value: 3 },
      ],
      content: [],
      tableLoading: false,
      selectedRowKeys: [],
      selectedData: [],
      sourceList: [],
      tableColumns: [
        {
          colKey: "row-select",
          type: "multiple", //single,multiple
          width: 30,
          fixed: "left",
        },
        {
          colKey: "id",
          title: "ID",
          width: 100,
        },
        {
          colKey: "message",
          title: "评论内容",
          width: 120,
        },
        {
          colKey: "attachment",
          title: "评论附件",
          width: 80,
        },
        {
          colKey: "source",
          title: "评论来源",
          width: 100,
        },
        {
          colKey: "title",
          title: "来源标题",
          width: 120,
        },
        {
          colKey: "link",
          title: "来源链接",
          width: 120,
        },
        {
          colKey: "likeNum",
          title: "点赞数",
          width: 70,
        },
        {
          colKey: "tag",
          title: "标签",
          width: 100,
        },
        {
          colKey: "collectedAt",
          title: "采集时间",
          width: 160,
        },
        {
          colKey: "publishedAt",
          title: "发布时间",
          width: 160,
        },
      ],
      observer: null,
    };
  },

  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    visible(val) {
      this.show = val;
    },
  },
  mounted() {
    this.getSources();
    window.addEventListener("resize", this.throttle1);
    this.screen_height = window.innerHeight;
    console.log(this.screen_height);
    console.log("加载了");
  },

  methods: {
    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.tagId = "";
      this.pageParams.source = "";
      this.pageParams.contentKeyword = "";
      this.selectedRowKeys = [];
      if (this.$refs.searchTagNameRef) {
        this.$refs.searchTagNameRef.reset();
      }
      this.getList();
    },
    showModel() {
      this.show = true;
      this.resetParams();
      setTimeout(() => {
        this.element = document.getElementById("div-resize");
        console.log(window.getComputedStyle(this.element).height);
        let MutationObserver =
          window.MutationObserver ||
          window.WebKitMutationObserver ||
          window.MozMutationObserver;
        this.observer = new MutationObserver(() => {
          this.throttle2();
          // this.searchHeight = window.getComputedStyle(this.element).height;
          console.log("检测到变化了", this.searchHeight);
        });
        this.observer.observe(this.element, { childList: true, subtree: true });
      }, 1000);
    },
    addComment() {
      this.$refs.detail.showModel();
    },
    handleClose() {
      this.show = false;
      this.selectedRowKeys = [];
      this.selectedData = [];
      if (this.observer) {
        this.observer.disconnect();
        this.observer.takeRecords();
        this.observer = null;
      }
    },
    //搜索
    search() {
      this.pageParams.page = 1;
      if (this.$refs.searchTagNameRef) {
        this.$refs.searchTagNameRef.setCache();
      }
      this.getList();
    },
    searchTagChange(selectTags) {
      this.pageParams.tagId = selectTags.toString();
      this.search();
    },
    //获取列表数据
    getList() {
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      console.log("搜索参数", params);
      this.tableLoading = true;
      article.commentList(params).then((resp) => {
        console.log("评论列表", resp);
        if (resp.code === 0) {
          this.tableLoading = false;
          if (resp.data) {
            if (resp.data.items) {
              this.items = resp.data.items;
              this.pageTotal = resp.data.total;
            }
          }
        }
      });
    },
    save() {
      if (!this.selectedData[0]) {
        this.info("未选择数据");
        return;
      }
      let current = {
        code: "comment",
        item: this.another(this.selectedData),
      };
      this.handleClose();
      this.$emit("pageCallback", current);
    },
    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },
    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "comments") {
        this.pageParams.page = 1;
        this.getList();
      }
      if (obj.code === "storage") {
        this.pageParams.page = 1;
        this.getList();
      }
    },
    //显示审核状态
    show_state(state) {
      if (state === 0) {
        return "草稿";
      } else if (state === 1) {
        return "通过";
      } else if (state === 2) {
        return "驳回";
      } else if (state === 3) {
        return "待审核";
      }
    },
    // addContent() {
    //   this.content.push(11111);
    // },
    rehandleSelectChange(value, { selectedRowData }) {
      this.selectedRowKeys = value;
      this.selectedData = selectedRowData;
    },

    throttle1() {
      clearTimeout(this.timer1);
      this.timer1 = setTimeout(() => {
        console.log("调整高度");
        this.screen_height = window.innerHeight;
      }, 500);
    },
    throttle2() {
      clearTimeout(this.timer2);
      this.timer2 = setTimeout(() => {
        console.log("调整搜索栏高度");
        this.searchHeight = window.getComputedStyle(this.element).height;
      }, 500);
    },
    getSources() {
      let source = [{ text: "筛选平台", value: "" }];
      comment.source().then((resp) => {
        if (resp.data) {
          resp.data.map((item) => {
            source.push({ text: item, value: item });
          });
          this.sourceList = source;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 10px 15px 0px;
  background-color: white;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}
::v-deep .el-dialog {
  display: flex !important;
  flex-direction: column !important;
  margin: 0 !important;
  position: relative !important;
  max-height: 95vh !important;
}

::v-deep .table-content-dialog {
  overflow-y: hidden !important;
}

.dialog-common-xb {
  display: flex;
  flex-direction: column;
  max-height: calc(95vh - 141px); //内容高度
  overflow: hidden;
}
::v-deep th {
  padding: 8px 8px 7px 8px;
}
::v-deep td {
  padding: 8px 8px 7px 8px;
}
</style>
